import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import {IssuersPage} from "./pages/IssuersPage";
import {Header} from "./components/PageTemplate/Header";
import {Footer} from "./components/PageTemplate/Footer";
import {HelpPage} from "./pages/HelpPage";
import {CredentialsPage} from "./pages/CredentialsPage";
import {RedirectionPage} from "./pages/RedirectionPage";
import {useSelector} from "react-redux";
import {RootState} from "./types/redux";
import {getDirCurrentLanguage} from "./utils/i18n";
import {PageNotFound} from "./pages/PageNotFound";
import {AuthorizationPage} from "./pages/AuthorizationPage";
import {HomePage} from "./pages/HomePage";
import LandingPage from "./components/LandingPage/LandingPage";
import GraduatesPage from "./components/GraduatesPage/GraduatesPage";
import Issuers from "./components/IssuerspPage/IssuersPage";
import VerifierPage from "./components/VerifierPage/VerifierPage";
import Faq from "./components/FaqSection/FaqSection"
import PublicationsPage from "./components/PublicationsPage/PublicationsPage"
import FeaturedWhitePaperPage from "./components/PublicationsPage/FeaturedWhitePaperPage"
import PublicationsLibraryPage from "./components/PublicationsPage/PublicationsLibraryPage"
import EventPage from "./components/EventPage/EventPage"
import PrivacyPolicyPage from "./components/PrivacyPolicyPage/PrivacyPolicyPage"



export const AppRouter = () => {
    const language = useSelector((state: RootState) => state.common.language);
    const wrapElement = (element: JSX.Element, isBGNeeded: boolean = true) => {
        return <React.Fragment>
            <div className={!isBGNeeded ? `min-h-screen min-h-72 bg-iw-background font-base flex flex-col` : `min-h-screen min-h-72 bg bg-iw-background font-base flex flex-col` } dir={getDirCurrentLanguage(language)}>
                <Header/>
                <div className={"mt-20 flex-1"}>
                    {element}
                </div>
                <Footer/>
            </div>
        </React.Fragment>
    }

    return (<BrowserRouter>
        <Routes>
            <Route path="/" element={<LandingPage/>}/>
            <Route path="/graduation" element={(<GraduatesPage />)} />
            <Route path="/verifier" element={(<VerifierPage />)} />
            <Route path="/issuer" element={(<Issuers />)} />
            <Route path="/faq" element={(<Faq />)} />
            <Route path="/event" element={(<EventPage />)} />
            <Route path="/privacy-policy" element={(<PrivacyPolicyPage />)} />
            <Route path="/publication" element={(<PublicationsPage />)} />
            <Route path="/publication/library" element={(<PublicationsLibraryPage />)} />
            <Route path="/publication/verifytt-embedding-trust" element={(<FeaturedWhitePaperPage />)} />
            <Route path="/publications" element={<Navigate to="/publication" replace />} />
            <Route path="/publications/library" element={<Navigate to="/publication/library" replace />} />
            <Route path="/publications/verifytt-embedding-trust" element={<Navigate to="/publication/verifytt-embedding-trust" replace />} />
            {/* <Route path="/" element={wrapElement(<HomePage/>, false)}/> */}
            <Route path="/issuers" element={wrapElement(<IssuersPage/>)}/>
            <Route path="/issuers/:issuerId" element={wrapElement(<CredentialsPage/>)}/>
            <Route path="/help" element={wrapElement(<HelpPage/>)}/>
            <Route path="/redirect" element={wrapElement(<RedirectionPage/>)}/>
            <Route path="/authorize" element={wrapElement(<AuthorizationPage/>)}/>
            <Route path="/*" element={wrapElement(<PageNotFound/>)}/>
            
        </Routes>
    </BrowserRouter>)
}



